<div class="row">
  <div class="row container-style">
    <span class="liquidation-data d-flex justify-content-start gap-4">
      <p><b>Sucursal: </b>{{branchName}}</p>
      <p><b>Nro. Corte: </b>{{subrentalCutoffCode}}</p>
      <p><b>Fecha: </b>{{subrentalCutoffDate}}</p>
    </span>
  </div>
  <div class="row container-style mt-2" *ngIf="showLiquidationProgress">
    <h6><b>Proceso de Liquidación</b></h6>
    <app-custom-progress-bar class="mt-1" [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
  </div>
  <div id="container-liquidation" class="row container-style mt-2" *ngIf="visiblePdf">
    <div id="list">
      <div class="d-flex justify-content-between">
        <p class="mb-2"><b class="style-text">Lista de Errores y Alertas</b></p>
        <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
          (onClick)="downloadErrorsTxt()"></app-custom-button>
      </div>
      <hr class="my-2">
      <div id="container-alerts" *ngFor="let liquidationAlert of liquidationAlerts">
        <p [ngClass]="errorLiquidation == 1 ? 'message-error' : 'message-alert'">
          {{liquidationAlert.message}}
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="d-flex justify-content-end gap-2 mt-3">
    <app-custom-button [title]="'Iniciar'" [label]="'Iniciar'" [disabled]="disabledStart"
      (onClick)="liquidated()"></app-custom-button>
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
      (onClick)="close()"></app-custom-button>
  </div>
</div>